import { aoiservice } from "../_services/aoi-report.service";
// import { localstorageSession } from '../_helpers/localstorage-session';

export const AOIanalysis = {
  namespaced: true,
  state: {
    layers: [],
  },
  getters:{
    getLayers(state){
      return state.layers;
    }
  },
  mutations: {
    post(response) {
      
    },
    setLayers(state,layers){
      state.layers = layers;
    },
    addLayer(state,layer){
      state.layers.push(layer);
    }
  },
  actions: {
    async post({ dispatch, commit, getters }, data) {
      await aoiservice
        .postAnalysis(data)
        .then(response => {
          commit("post", response);
        })
        .catch(error => {
          
        });
    },
    async get({ dispatch, commit, getters }) {
      await aoiservice
        .getAnalysisAOI()
        .then(response => {
          commit("post", response);
        })
        .catch(error => {
          console.warn(error);
        });
    },
    addLayer({commit},layer){
      commit("addLayer",layer);
    },
    setLayers({commit},layers){
      commit("setLayers",layers);
    }
  }
};
